import type { Notifications } from '../types';

/**
 * Get the total notification count for the user. This is shown in the header
 * user button as a badge count.
 * @param notifications The notifications object.
 * @param orderNotificationCount The order notification count (from the User object).
 * @returns The total notification count.
 */
export function getTotalNotificationCount(
    notifications: Notifications,
    orderNotificationCount: number
): number {
    return (
        (notifications.website?.count ?? 0) +
        (notifications.userInbox?.count ?? 0) +
        orderNotificationCount
    );
}
